import React from 'react';
import OpenDNSBanner from '../../../components/OpenDNSBanner';
import { AnimatedTextInput, AnimatedSelect, AnimatedButton, HeroImageBanner } from '@opendns/opendns-dpl';
import Store from '../store';
import utils from '../../../utils';
import { browserHistory } from 'react-router';

class MainForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            errors: {
                empty: {
                    email: 'Email Address is required'
                },
                invalid: {
                    email: 'Email Address is invalid'
                }
            },
            revealCriteria: false
        };
    }

    handleForm(e) {
        e.preventDefault();
    }

    checkTA15(callback) {
        // TODO uncomment when TA15 works
        // utils.callApi(
        //     { testing_uri: window.location.pathname },
        //     'internals/1/ta15',
        //     (data) => {
        //         if (data.response === 'M') {
        //             browserHistory.push('/premiumdns/error/hold');
        //         } else if (data.response === 'C') {
        //             browserHistory.push('/premiumdns/error/country');
        //         } else if (data.response === 'N') {
        //             callback();
        //             //browserHistory.push('https://www.opendns.com/setupguide');
        //         } else {
        //             browserHistory.push('/premiumdns/error/system');
        //         }
        //     },
        //     (data) => {
        //         browserHistory.push('/premiumdns/error/system');
        //     },
        //     'PUT'
        // );

        // we're having troubles with TA15 now so we'll skip testing it
        callback.call(this);
    }

    handleSubmit() {
        let data = {};
        let proceedFlag = true;

        for (var ref in this.refs) {
            if( this.refs.hasOwnProperty( ref ) ) {
                let field = this.refs[ref];
                data[field.props.name] = field.state.value;

                if (!field.state.isValid && field.props.isRequired) {
                    field.setState({
                        validationMessage: this.state.errors.invalid[field.props.name],
                        isAlerting: true
                    });
                    proceedFlag = false;
                }
                if (!field.state.value && field.props.isRequired) {
                    field.setState({
                        validationMessage: this.state.errors.empty[field.props.name],
                        isAlerting: true
                    });
                    proceedFlag = false;
                }
            }
        }

        if (proceedFlag) {
            Store.dispatch({type: 'UPDATE', data: { submitData: data } });
            this.checkTA15(this.postForm);
        }
    }

    postForm() {
        let submitData = Store.getState().submitData;

        $.ajax({
            url: '/familyshield/submit',
            type: 'POST',
            data: JSON.stringify(submitData),
            contentType: 'application/json',
            success: this.doneCallback,
            error: this.failCallback
        });
    }

    doneCallback(data, textStatus, jqXHR) {
        window.location = 'https://www.opendns.com/setupguide/?url=familyshield';
    }

    failCallback(jqXHR, textStatus, errorThrown) {
        browserHistory.push('/familyshield/error/');
    }

    render() {

        return (
            <div classnName="mainform-container">
                <section className="cisco-banner">
                    <div className="cisco-banner__logo">
                        <a href="http://www.cisco.com/" target="_blank">
                            <img src="https://d15ni2z53ptwz9.cloudfront.net/opendns-www/img/Cisco_Logo_RGB_Screen_White.png" className="cisco-banner__logo__img cisco-banner__logo__img--light" alt="OpenDNS is now a part of Cisco" title="OpenDNS is now a part of Cisco" />
                            <img src="https://d15ni2z53ptwz9.cloudfront.net/opendns-www/img/cisco-dark-logo.png" className="cisco-banner__logo__img cisco-banner__logo__img--dark" alt="OpenDNS is now a part of Cisco" title="OpenDNS is now a part of Cisco" />
                        </a>
                    </div>
                    <div className="cisco-banner__learn">
                        <p>
                            <span>OpenDNS is now part of Cisco</span>
                            <a href="http://www.cisco.com/web/about/ac49/ac0/ac1/ac259/opendns.html" target="_blank" className="cisco-banner__learnLink">
                                <span>Learn More </span>
                                <i className="fa fa-caret-right"></i>
                            </a>
                        </p>
                    </div>
                    <div className="cisco-banner__about">
                        <a href="http://www.cisco.com/web/about/index.html" target="_blank">About Cisco</a>
                    </div>
                </section>
                <OpenDNSBanner />

                <HeroImageBanner
                    size="small"
                    imageUrl="/images/Premium-DNS-Hero-Full-Page.png"
                >
                    <h1 className="hero-banner__heading">OpenDNS Family Shield</h1>
                </HeroImageBanner>

                <div className="grid">
                    <div className="main-column">
                        <h2>Set up FamilyShield</h2>

                        <div className="included-list">
                            <h3>What Is Included</h3>
                            <p style={{padding: 0}}>You&apos;re minutes away from making the Internet safer for everyone in your household. FamilyShield is the single easiest way to protect your kids online, block adult websites, and protect your family from phishing and malware. Completely free.</p>
                        </div>

                    </div>
                    <div className="sidebar">
                        <p className="intro">Where should we send FamilyShield updates?</p>

                        <div>
                            <form noValidate id="familyshield-signup" action="/familyshield/submit" method="POST" onSubmit={this.handleForm.bind(this)}>
                                <AnimatedTextInput
                                    ref="email"
                                    name="email"
                                    label="Email address"
                                    isRequired={true}
                                    regex="^[A-Za-z0-9\.\-_\+]+@[A-Za-z0-9\.\-_]+\.[A-Za-z]+$"
                                />
                                <div className="form-bullets">
                                    <ul>
                                        <li><i className="fa fa-fw fa-angle-double-right"></i>We&apos;d like to know the best way to get in touch with you about important service-related news.</li>
                                        <li><i className="fa fa-fw fa-angle-double-right"></i>We hate spam too, so we won&apos;t spam you.</li>
                                    </ul>
                                </div>
                                <AnimatedButton
                                    isSubmit={true}
                                    isFullWidth={true}
                                    onClick={this.handleSubmit.bind(this)}>
                                        Let&apos;s Begin!
                                </AnimatedButton>
                            </form>
                        </div>

                        <div className="formrow" id="fineprint">
                            <p>Or, <a href="https://www.opendns.com/setupguide/?url=familyshield">continue</a> setup without signing up.</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default MainForm;



// WEBPACK FOOTER //
// ./src/familyshield/js/partials/MainForm.js